import { ClientGroupCode } from '@domgen/dgx-fe-common';
import { PersonalDetailsFormConfig } from '../../models/personal-details/personal-details-form-config.interface';
import { mockCmsPersonalDetailsForm } from './cms-personal-details-form.mock';
import { mockPersonalDetailsFormValue } from './personal-details-form-value.mock';

export const mockPersonalDetailsFormConfig: PersonalDetailsFormConfig = {
  cmsData: mockCmsPersonalDetailsForm,
  groupCodes: [ClientGroupCode.Beko],
  hasExistingSelectedQuotes: true,
  initialValue: mockPersonalDetailsFormValue,
  privacyPolicy: false,
};
